export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(AnybillLogger);
});
